import type { TelError, TelErrorJson } from './tel-error-data.js'
import { SerializableError } from './tel-error-data.js'

export interface DomainErrorData {
  userMessage: unknown[] // result of i18tArgs
  domainErrorType: string
  shouldContactSupport?: boolean
}

export class BaseDomainError<TDomainErrorType extends string = string>
  extends SerializableError
  implements TelError
{
  serializable = true

  constructor(
    public readonly domainErrorType: TDomainErrorType,
    public readonly userMessage: unknown[],
    opts?: {
      shouldContactSupport?: boolean
      message?: string
    },
  ) {
    super(opts?.message || String(userMessage))
    this.name = this.constructor.name
  }

  toJSON(): TelErrorJson {
    return {
      type: 'domain',
      code: 400, // Domain errors are typically client errors
      message: this.message,
      stack: this.stack,
      errorData: {
        userMessage: this.userMessage,
        domainErrorType: this.domainErrorType,
      },
    }
  }

  prepareForDisplay(): DomainErrorData {
    return {
      userMessage: this.userMessage,
      domainErrorType: this.domainErrorType,
    }
  }
}
